import { FC } from 'react';
import { Grid, Chip } from '@material-ui/core';
import useStyles from '../../assets/styles/Uikit.css';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
type Label = {
  id: number;
  name: string;
};
type Props = {
  labels: Label[];
};

/**
 * ラベル表示
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const LabelList: FC<Props> = (props: Props) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1}>
      {props.labels.map((label: Label) => (
        <Grid item md={4} xs={4} key={label.id}>
          <Chip
            classes={{ root: classes.toggleLabelChips }}
            label={label.name}
            size="small"
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default LabelList;
